import { render } from "./Elerhetoseg.vue?vue&type=template&id=2278cda2&scoped=true"
import script from "./Elerhetoseg.vue?vue&type=script&lang=js"
export * from "./Elerhetoseg.vue?vue&type=script&lang=js"

import "./Elerhetoseg.vue?vue&type=style&index=0&id=2278cda2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\source\\MFVK\\menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2278cda2"]])

export default __exports__